import { css, Interpolation, Theme } from '@emotion/react'
import { tabsClasses } from '@mui/material/Tabs'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  max-width: 1190px;
  padding: 24px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

export const title: Interpolation<Theme> = (theme) => css`
  font-size: 22px;
  font-weight: 700;
  line-height: 27.72px;
  padding-bottom: 24px;

  ${theme.breakpoints.down('lg')} {
    padding-top: 24px;
  }
`

export const content: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const statisticsTabs: Interpolation<Theme> = css`
  min-height: 0;

  .${tabsClasses.list} {
    gap: 10px;
    flex-wrap: wrap;
  }

  .MuiTabs-indicator {
    display: none;
  }
`

export const statisticsTab: Interpolation<Theme> = (theme) => css`
  min-width: 0;
  min-height: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  padding: 12px 12px 8px;
  border-radius: 12px;
  text-transform: none;
  opacity: 1;

  &.Mui-selected {
    color: ${theme.typographyColors.typographyTwo};
  }
`

export const activeStatisticsTab: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  background: ${theme.colors.grayHover};
`

export const filtersContainer: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const filters: Interpolation<Theme> = css`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`

export const tabs: Interpolation<Theme> = css`
  margin: 0;
`

export const chartsWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
